

import React, { memo } from 'react';
import { SizeMe } from 'react-sizeme';

import EmptyDataPlaceholder from '../components/EmptyDataPlaceholder';
import { NUMERIC_MEDIA_SIZES } from '../../../../../common/styles/vars';






const EmptyDataPlaceholderContainer = ({
  customSearchText,
  searchTerm
}) =>
<SizeMe monitorHeight>
    {({ size }) => {
    const windowSize = size.width && size.height ? size : { width: 1, height: 1 };
    const isMobile = windowSize.width < NUMERIC_MEDIA_SIZES.small;

    return (
      <EmptyDataPlaceholder
        isMobile={isMobile}
        customSearchText={customSearchText}
        searchTerm={searchTerm} />);


  }}
  </SizeMe>;


export default memo(EmptyDataPlaceholderContainer);